<template>
  <v-form class="filters block pb-sm-12">
    <h3 class="mb-6"><v-icon>search</v-icon>Search</h3>
    <v-menu
      ref="dateFromContainer"
      v-model="dateFromContainer"
      dense
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="290px"
    >
      <template #activator="{ on }">
        <v-text-field
          v-model="dateFormattedFrom"
          dense
          label="Date from"
          prepend-icon="event"
          @blur="date = parseDate(dateFormattedFrom)"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="searchParams.from_date"
        no-title
        @input="dateFromContainer = false"
      ></v-date-picker>
    </v-menu>

    <v-menu
      ref="dateToContainer"
      v-model="dateToContainer"
      dense
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="290px"
    >
      <template #activator="{ on }">
        <v-text-field
          v-model="dateFormattedTo"
          dense
          label="Date to"
          prepend-icon="event"
          @blur="date = parseDate(dateFormattedTo)"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="searchParams.to_date"
        no-title
        @input="dateToContainer = false"
      ></v-date-picker>
    </v-menu>

    <!-- Image Search filters only -->
    <span v-show="hideForCollection">
      <select-extend
        v-if="currentUser.roles.includes('client-manager') === true"
        v-model="searchParams.cycle_id"
        :items="cycleItems"
        item-text="title"
        item-value="id"
        label="Cycle"
        @change="cycleChange()"
      />

      <select-extend
        v-model="searchParams.chain_id"
        :items="chainItems"
        item-text="name"
        item-value="id"
        label="Chain"
      />

      <select-extend
        v-model="searchParams.sub_call_id"
        :items="subCallItems"
        item-text="name"
        item-value="id"
        label="Subcall"
      />

      <v-autocomplete
        v-model="searchParams.store_id"
        :loading="isLoading"
        :search-input.sync="storeSearch"
        :items="storeItems"
        placeholder="Store start typing to Search"
        item-text="name"
        item-value="id"
        label="Store"
        class="mb-3"
        clearable
        filled
        dense
        solo
        hide-details
        flat
      ></v-autocomplete>

      <select-extend
        v-if="currentUser.roles.includes('client-manager') === true"
        v-model="searchParams.show"
        :items="showMeItems"
        placeholder="Show me"
        item-text="name"
        item-value="id"
        label="Show me"
      />

      <select-extend
        v-if="currentUser.roles.includes('client-manager') === true"
        v-model="searchParams.client_region_id"
        :items="clientRegionItems"
        item-text="name"
        item-value="id"
        label="Client regions"
        @change="regionChange()"
      />

      <select-extend
        v-if="currentUser.permissions.publish_photos === true"
        v-model="searchParams.published_status"
        :items="publishedItems"
        item-text="name"
        item-value="id"
        label="Published status"
      />

    <select-extend
      v-if="currentUser.roles.includes('client-manager') === true"
      v-model="searchParams.overwritten_status"
      :items="overwrittenItems"
      item-text="name"
      item-value="id"
      label="Retake status"
    />
    </span>

    <v-text-field
      v-model="searchParams.search"
      label="Search"
      class="mb-3"
      multiple
      chips
      flat
      dense
      clearable
      prepend-icon="mdi-magnify"
    ></v-text-field>

    <v-select
        v-model="searchParams.orderBy"
        :items="orderByOptions"
        item-text="name"
        item-value="id"
        label="Order by"
        class="mb-3"
        clearable
        filled
        dense
        solo
        hide-details
        flat
        @change="updateOrderBy"
      ></v-select>

    <v-btn right color="primary" class="mt-2" @click="clearSearch()">
      Clear
      <v-icon right>mdi-close-circle</v-icon>
    </v-btn>

    <v-btn
      :disabled="loading == true"
      right
      color="primary"
      class="ml-2 mt-2"
      @click="doSearch()"
      >Search</v-btn
    >
    <v-progress-circular
      v-if="loading == true"
      :size="28"
      right
      indeterminate
      color="primary"
    ></v-progress-circular>
  </v-form>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store/";
import {
  PHOTO_SEARCH,
  PHOTO_SEARCH_RESET,
  SELECTED_RESET,
  FETCH_EXPCLIENT,
  NEW_SEARCH_IDENTIFIER,
} from "@/store/actions.type";
import ApiService from "@/common/api.service";

import toast from "@/services/toast";
import router from "../router";

export default {
  name: "MainFilters",
  data() {
    return {
      orderByOptions: [
        {'id': 'timestamp_desc', 'name': 'Order by Newest First'},
        {'id': 'timestamp_asc', 'name': 'Order by Oldest First'},
        {'id': 'store_code_asc', 'name': 'Order by Store Code ASC'},
        {'id': 'store_code_desc', 'name': 'Order by Store Code DESC'},
      ],
      dateFormattedFrom: null,
      dateFormattedTo: null,
      dateFromContainer: false,
      dateToContainer: false,
      storeSearch: null,
      isLoading: false,
      loading: false,
      storeEnabled: true,
      searchParams: {},
      initSearch: {
        chain_id: null,
        store_id: null,
        client_region_id: null,
        sub_call_id: null,
        cycle_id: null,
        from_date: null,
        to_date: null,
        search: "",
        published_status: null,
        overwritten_status: null,
        show: "exclude-signatures",
        collection_id: null,
        per_page: 25,
        page: 1,
        orderBy: 'timestamp_desc',
      },
      publishedItems: [
        { name: "Unpublished", id: "unpublished" },
        { name: "Published", id: "published" },
      ],
      overwrittenItems: [
        { name: "Has been retaken", id: "overwritten" },
        { name: "Is a retake", id: "is_overwrite" },
      ],
      showMeItems: [
        { name: "Photos & Signatures", id: "all" },
        // { name: "Photos only", id: "photos" },
        { name: "Signatures only", id: "signatures" },
        { name: "Exclude Signatures", id: "exclude-signatures" },
      ],
      clientRegionItems: [],
      cycleItems: [],
      chainItems: [],
      storeItems: [{ name: "Type to search", id: "" }],
      subCallItems: [],
    };
  },
  computed: {
    hideForCollection() {
      if (this.$route.params.collectionId) {
        return false;
      }
      return true;
    },
    clientId() {
      let cid = null;

      if (this.$route.params.clientId) {
        cid = this.$route.params.clientId;
      } else if (this.activeExpClientId) {
        cid = this.activeExpClientId;
      }

      return cid;
    },
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    dateFrom() {
      return this.searchParams.from_date;
    },
    dateTo() {
      return this.searchParams.to_date;
    },
    ...mapGetters(["activeExpClient", "activeExpClientId", "currentUser"]),
  },

  watch: {
    storeSearch() {
      this.isLoading = true;
      this.getStoreFieldItems().finally(() => {
        this.isLoading = false;
      });
    },
    dateFrom() {
      this.dateFormattedFrom = this.formatDate(this.dateFrom);
    },
    dateTo() {
      this.dateFormattedTo = this.formatDate(this.dateTo);
    },
  },

  mounted() {
    // Set default searchParams
    this.$nextTick(() => {
      this.searchParams = this.initSearch;
      if (this.activeExpClient != null) {
        this.filterLaunch();
      } else {
        store.dispatch(FETCH_EXPCLIENT).then(() => {
          this.filterLaunch();
        });
      }
    });
  },

  methods: {
    updateOrderBy(newValue) {
      this.searchParams.orderBy = newValue
    },
    // Helper to format date.
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    // Helper to format date.
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    // If a chain is selected get store data.
    storefieldCheck() {
      if (this.searchParams.chain_id) {
        this.storeEnabled = false;
        return this.getStoreFieldItems();
      }
      this.storeEnabled = true;
      return this.storeEnabled;
    },

    // Get items for store field.
    getStoreFieldItems() {
      const params = {
        client_id: this.clientId,
        chain_id: this.searchParams.chain_id,
      };
      if (this.storeSearch) params.search = this.storeSearch;
      if (this.searchParams.region_id > 0) {
        params.region_id = this.searchParams.region_id;
      }
      return this.getFilterData("stores", "storeItems", params);
    },

    cycleChange() {
      if (this.searchParams.cycle_id) {
        const params = {
          client_id: this.clientId,
          cycle_id: this.searchParams.cycle_id,
        };
        this.getFilterData("sub-calls", "subCallItems", params);
      }
    },

    /**
     * Reset the search.
     */
    clearSearch() {
      this.searchParams = this.initSearch;
      store.dispatch(NEW_SEARCH_IDENTIFIER)
      // Reset url
      if (Object.keys(this.$route.query).length > 0)
        router.push({ query: {} }).catch((e) => {
          console.log(e);
        });
      this.loading = false;
    },

    /**
     * Helper function to populate a filter from the API.
     */
    async getFilterData(endpoint, model, params = {}) {
      const filterQueryParams = params;
      filterQueryParams.client_id = this.clientId;

      const { data } = await ApiService.query(endpoint, { params });
      this[model] = data.data;
    },

    /**
     * Populate the filters with api data.
     */
    filterLaunch() {

      this.getFilterData("sub-calls", "subCallItems", {
        client_id: this.clientId,
      });
      this.getFilterData("chains", "chainItems", { client_id: this.clientId });
      this.getFilterData("client-regions", "clientRegionItems");
      this.getFilterData("cycles", "cycleItems", { client_id: this.clientId })
        .then(() => {
          // Populate values from url.
          Object.keys(this.$route.query).forEach((key) => {
            if (Number.isNaN(Number(this.$route.query[key]))) {
              this.searchParams[key] = this.$route.query[key];
            } else {
              this.searchParams[key] = parseInt(this.$route.query[key], 10);
            }
          });
          // Set Storefield
          this.storefieldCheck();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /**
     * Reset and run search
     */
    doSearch() {
      store.dispatch(NEW_SEARCH_IDENTIFIER)

      const searchQuery = {};
      // Remove empty values
      Object.keys(this.searchParams).forEach((key) => {
        if (this.searchParams[key]) {
          searchQuery[key] = this.searchParams[key];
        }
      });
      // Set the active client.
      if (this.clientId !== null) {
        searchQuery.client_id = this.clientId;
      }
      if (this.$route.params.collectionId) {
        searchQuery.collection_id = this.$route.params.collectionId;
      }

      // Clear selected
      store.dispatch(SELECTED_RESET);
      store
        .dispatch(PHOTO_SEARCH_RESET)
        .then(() => {
          searchQuery.page = 1;
          // Push query to url.
          if (Object.keys(searchQuery).length > 0) {
            router.push({ query: searchQuery }).catch((e) => {
              console.log(e);
            });
          }
          this.loading = true;
        })
        .then(() => {
          store
            .dispatch(PHOTO_SEARCH, searchQuery)
            .then(() => {
              this.loading = false;
            })
            .catch((err) => {
              toast.error("Something went wrong");
              console.log(err);
              this.loading = false;
            });
        });
    },
  },
};
</script>
